const initQuickSearch = () => {
  const inputField = document.getElementById('quick-search-input');
  const form = document.getElementById('quick-search');
  const searchResultsContainer = document.getElementById('quick-search-results');

  if (!inputField || !form) return;

  const redirectToSearch = (searchQuery) => {
    if (searchQuery.length >= 2) {
        const postType = form.getAttribute('data-content-type');
        let redirectUrl = '';

        if (postType === 'program') {
          redirectUrl = `/academics/undergraduate-academics/majors-and-programs/?filter-s=${encodeURIComponent(searchQuery)}#filter-search-input`;
        } else if (postType === 'person') {
          redirectUrl = `/directory/?tab=people&filter-sp=${encodeURIComponent(searchQuery)}`;
        } else if (postType === 'office') {
          redirectUrl = `/directory/?tab=offices&filter-so=${encodeURIComponent(searchQuery)}`;
        } else if (postType === 'housing') {
          redirectUrl = `/housing/?f_s=${encodeURIComponent(searchQuery)}#filter-search-input`;
        } else if (postType === 'club-activity') {
          redirectUrl = `clubs-activities/?f_s=${encodeURIComponent(searchQuery)}#filter-search-input`;
        }
        else {
            redirectUrl = `/?s=${encodeURIComponent(searchQuery)}`;
        }

        window.location.href = redirectUrl;
    }
  };

  // Redirect the user to the search results page when they click the search button.
  form.addEventListener('submit', (event) => {
      event.preventDefault();
      const searchQuery = inputField.value.trim();
      redirectToSearch(searchQuery);
  });

  inputField.addEventListener('input', () => {
      const searchQuery = inputField.value;
      const postType = form.getAttribute('data-content-type');

      // Update the data-cceventlabel value as user types
      form.setAttribute('data-cceventlabel', `block_quick-search_term_${searchQuery}`);

      if (searchQuery.length < 2) {
        searchResultsContainer.innerHTML = '';
        return;
      }

      if (searchQuery.length === 0) {
        searchResultsContainer.innerHTML = '';
        return;
      }

      fetch(`/wp-json/champlain/v1/quick-search/?query=${encodeURIComponent(searchQuery)}&postType=${encodeURIComponent(postType)}`)
        .then(response => response.json())
        .then(data => {
          console.cclog(data);
          if (!Array.isArray(data)) {
              console.error('Response is not an array:', data);
              return;
          }

          let resultList = '<ul>';
          data.forEach(item => {
              let ccEventLabel = 'block_quick-search_link_' + item.title;
              resultList += `<li><a data-cceventname="block_quick-search" data-cceventaction="block_quick-search_click_result-for-term_${searchQuery}" data-cceventlabel="${ccEventLabel}" href="${item.link}">${item.title}</a></li>`;
          });
          resultList += '</ul>';
          searchResultsContainer.innerHTML = resultList;
      })
      .catch(error => console.error('Error:', error));
  });

  // Redirect the user to the search results page when they press enter.
  // inputField.addEventListener('keypress', (event) => {
  //     if (event.key === 'Enter') {
  //         event.preventDefault();
  //         const searchQuery = inputField.value.trim();
  //         redirectToSearch(searchQuery);
  //     }
  // });
  
};

export default initQuickSearch;
